import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RoutesPath } from "../../constants";
import Dashboardsidebar from "../../layouts/Dashboardsidebar";

const ProfilePage = () => {
  const navigate = useNavigate();

  const [profileData, setProfileData] = useState({
    name: "",
    email: "",
    photo: ""
  });

  useEffect(() => {
    const name = localStorage.getItem("userName") || "";
    const email = localStorage.getItem("email") || "";
    const photo = localStorage.getItem("userPhoto") || "";

    setProfileData({
      name,
      email,
      photo
    });
  }, []);

  const handleCancel = () => {
    navigate(RoutesPath.DASHBOARD);
  };

  return (
    <Dashboardsidebar>
      <div className="profile-container">
        <div className="profile-header">
          <h2>My Profile</h2>
          <p>Your GetSigned account details</p>
        </div>

        <div className="profile-card">
          {/* <div className="profile-left">

            {profileData.photo ? (
              <img
                src={profileData.photo}
                alt="Profile"
                className="profile-photo"
              />
            ) : (
              <div className="profile-photo empty-photo"></div>
            )}

          </div> */}
          <div className="profile-right">
            <div className="profile-field">
              <label>Full Name</label>
              <input type="text" value={profileData.name} disabled />
            </div>

            <div className="profile-field">
              <label>Email ID</label>
              <input type="email" value={profileData.email} disabled />
            </div>

            <div className="profile-actions">
              <button className="btn btn-dark" onClick={handleCancel}>
                <i className="fa fa-times"></i> Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dashboardsidebar>
  );
};

export default ProfilePage;